import React, { Component } from 'react';
import { Modal, Table } from 'antd';
import moment from 'moment';

import { queryIncubatorRefundTodo } from '@api/incubator/base';

class ModalIncomeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      selectedRowKeys: [],
    };
  }

  componentDidMount() {
    this.customUuid = this.props.customUuid;
    this.choosedDatas = [];
    this.getData();
    this.getInitselectedRowKeys();
  }

  getInitselectedRowKeys = () => {
    const selectedRowKeys = [];
    this.props.selectedRows.forEach(item => selectedRowKeys.push(item.uuid));
    this.setState({
      selectedRowKeys,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.customUuid !== this.props.customUuid) {
      this.customUuid = nextProps.customUuid;
      this.getData();
    }
  }

  getData = () => {
    const current = this.current || 1;
    const pageSize = 5;
    queryIncubatorRefundTodo({
      customUuid: this.customUuid,
      incubatorUuid: this.props.incubatorUuid,
      uuid: this.props.incubatorUuid,
      limit: pageSize,
      target: 1,
      start: current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              current: current || 1,
              total: res.totalSize,
              pageSize,
            },
          },
        });
      }
    });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys });
    const current = this.current || 1;
    this.choosedDatas = this.choosedDatas || {};
    this.choosedDatas[current] = selectedRows;
  };

  handleVisible = (flag, fileParams) => {
    this.fileData = {};
    if (fileParams) {
      this.fileData = {
        type: fileParams.type,
        files: [
          {
            uuid: fileParams.uuid,
            name: fileParams.name,
            url: fileParams.url,
          },
        ],
      };
    }
  };

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        width: 100,
        render: (text, record, index) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '金额',
        dataIndex: 'money',
        width: 100,
      },
      {
        title: '类型',
        dataIndex: 'target',
        width: 80,
        render: (text, record) => <span>{text === 0 ? '支出' : '收入'}</span>,
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        width: 200,
      },
    ];
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getData();
  };

  formatChoosedDatas = params => {
    const { selectedRowKeys } = this.state;
    const { selectedRows = [] } = this.props;
    // 保存已选的数据，可能存在待翻页的数据
    let datas = selectedRows;
    const dataUuids = [];
    params.forEach(item => {
      const dataItem = item || [];
      datas = datas.concat(dataItem);
    });
    // 去除取消选择的数据
    datas = datas.filter(item => selectedRowKeys.indexOf(item.uuid) > -1);
    // 去重
    datas = datas.filter(item => {
      if (dataUuids.indexOf(item.uuid) < 0) {
        dataUuids.push(item.uuid);
        return item;
      }
      return false;
    });
    return datas;
  };

  handleOk = () => {
    const chooseDatas = this.formatChoosedDatas(this.choosedDatas);
    this.props.handleChooseData(chooseDatas);
    this.props.handleCancel(false);
  };

  render() {
    const { visible, handleCancel } = this.props;
    const {
      loading,
      dataSource: { list, pagination },
      selectedRowKeys,
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <Modal
        title="账单信息"
        visible={visible}
        onCancel={() => handleCancel(false)}
        width={680}
        onOk={this.handleOk}
      >
        <Table
          bordered
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="uuid"
          onChange={this.handleTableChange}
          loading={loading}
          rowSelection={rowSelection}
        />
      </Modal>
    );
  }
}

export default ModalIncomeList;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/ModalIncomeList.js